<template>
	<!-- Displays a list of products and a sidebar -->
	<Loading :loading="loading" class="row" id="listing">
		<div class="col-12 col-md-10 offset-md-1">
			<div class="row">
				<Breadcrumbs/>
			</div>
			<div class="row">
				<!-- scrollTo is scroll point for pagination change-->
				<h1 id="scrollTo" class="col-12 listingTitle">{{listingName}}</h1>
			</div>
			<div class="row">
				<div class="col-md-2">
					<ListingSidebar 
						:allProducts="listingData" 
						:products="products" 
						:brandsData="brandsInListingData"
						@brandsFirstEvent="brandsFirst = $event"
						@sortingAlgoEvent="sortingAlgo = $event"
					/>
					<CategorySidebar class="col-md-12"/>
				</div>
				<div class="col-12 col-md-10">
					<div class="row productListingOptions">
						<strong class="col-12 col-md-1">Show:</strong>
						<div class="col-6 col-md-3 showCount">
							<span
								v-for="option in showOptions"
								:key="option"
								@click="() => {itemsPerPage = option; pageNumber = 0;}"
								:class="{current: itemsPerPage == option}"
								class="displayOption"
							>
								<span class="displayOptionText">{{option == 10000 ? 'All' : option}}</span>
							</span>
						</div>

						<div class="col-12 offset-md-3 col-md-5">
							<SearchBar :searchFunc="debounceSearch" :placeholder="'Search ' + listingName" ref="searchBar" />
						</div>
					</div>

					<div class="row">
						<div v-if="products.length > 0" class="col-12">
							<transition-group name="fade" type="out-in" tag="div" class="row itemContainer" appear>
								<ListItem
								v-for="item in products"
								:key="item.id"
								:item="item"
								:source="'specials'"
								class="col-12 col-sm-6 col-md-4 col-lg-3"
								/>
							</transition-group>
							<PaginationButtons :pageNumber="pageNumber" :pageCount="pageCount"/>
						</div>
						<div v-else class="col-12 text-center my-4">
							<p>
								No related items are currently loaded on our website. Remember that we have <strong>over 550,000 products</strong> available so please use the ‘<router-link :to="{name: 'get-a-price'}">Request Price</router-link>’ button to submit your request and our quotes team will get back to you with a price and availability shortly
							</p>
							<p class="mt-4">
								Or try refining your filters to see more results.
							</p>
							<ClearFiltersButton class="btn btn-primary mx-auto mb-5" :extraFunc="() => {this.search = ''; this.$refs.searchBar.clear()}"/>
						</div>
					</div>
				
				</div>
			</div>
		</div>
		<!-- TODO what is this below -->
		<vue-headful :title="'Shop' + listingName + ' | Cherrytree'"/>
	</Loading>
</template>

<script>
import { mapState } from "vuex";
import { fetchAllSpecials} from "@/network/listingRequests";
import ListItem from "@/sections/shop/listing/ListItem";
import ListingSidebar from "@/sections/shop/listing/ListingSidebar";
import CategorySidebar from "@/sections/shop/category/CategorySidebar";
import Loading from "@/components/loading/Loading";

import SearchBar from "@/components/searchBar";

import Breadcrumbs from "@/components/breadcrumbs/Breadcrumbs";

import PaginationButtons from "@/components/paginationButtons";
import ClearFiltersButton from "@/components/buttons/ClearFiltersButton"

// import ListingBrands from "@/sections/shop/listing/ListingBrands";
// import ListingBrandsBottom from "@/sections/shop/listing/ListingBrandsBottom";
// import ListingBrandsSidebar from "@/sections/shop/listing/ListingBrandsSidebar";

import { filterListing } from "@/sections/shop/listing/filterListing";
import { sortListing } from "@/sections/shop/listing/sortListing";


export default {
	name: "SpecialsListing",
	components: {
		ListItem,
		PaginationButtons,
		Loading,
		ListingSidebar,
		SearchBar,
		CategorySidebar,
		// ListingBrands,
		// ListingBrandsBottom,
		Breadcrumbs,
		ClearFiltersButton,
	},
	data: () => {
		return {
			listingData: [], //will hold data about listing
			loading: false,
			itemsPerPage: 48, //default
			sortingAlgo: "recent", //sort by edit date by default for specials
			brandsFirst: false,
			searchTimeout: null, //store timeout for searching locally
			brandsInListingData: [],
		};
	},
	//called every time the before component is shown
	created() {
		this.getData();
	},
	methods: {
		getData() {
			this.loading = true;
			fetchAllSpecials(
				listing => {
					this.listingData = Object.values(listing);
					this.loading = false;
				},
				error => {
					console.log(error);
				}
			);
		},

		//saves computation by only searching maximum once every 150ms
		debounceSearch(val){
			if(this.searchTimeout) {
				clearTimeout(this.searchTimeout);
			}

			this.searchTimeout = setTimeout(() => {
				this.updateSearch(val)
			}, 150);
		},

		//update search params in route
		updateSearch(val){
			let oldQuery = this.$route.query;
			let newQuery;

			if(val == '') val = undefined;

			//if query defined, save old query so we don't lose brand filters etc
			if(oldQuery){
				newQuery = {...oldQuery, search: val}
			}else{
				newQuery = {search: val}
			}
			//update query search param
			this.$router.replace({query: newQuery})
		}
	},
	watch: {
		//check if the items present have changed and if they have then reset pagination to 0
		filtered: function(oldItems, newItems) {
			if (oldItems.length == newItems.length) {
				for (let i = 0; i < oldItems.length; i++) {
					if (oldItems[i] != newItems[i]) {
						this.pageNumber = 0;
						return;
					}
				}
			} else {
				this.pageNumber = 0;
			}
		},
		// check if category/subcategory has changed and fetch new data if so
		"$route.params"(oldVal, newVal) {
			if (oldVal.toString() == newVal.toString()) {
				return;
			}
			this.getData();
		},
	},
	computed: {
		...mapState({
			// map categories to store.reference.categories
			categories: state => state.reference.categories
		}),
		listingId() {
			return this.$route.params.subcategory;
		},
		filtered() {
			//setup refine id
			let { priceHigh, priceLow, brand, refine, search } = this.$route.query;
			let price_key = "member_price";

			return filterListing(
				this.listingData,
				priceHigh,
				priceLow,
				brand,
				refine,
				search,
				null,
				price_key
			);
		},
		sorted() {
			let priceKey = this.$store.state.auth.memberLevel;
			return sortListing(
				this.filtered,
				this.sortingAlgo,
				this.brandsFirst,  // Here in case this ever gets used as a thing
				true,
				priceKey
			)
		},
		paginated() {
			const start = (this.pageNumber -1) * this.itemsPerPage;
			const end = start + this.itemsPerPage;
			return this.sorted.slice(start, end);
		},
		pageCount() {
			let l = this.filtered.length,
				s = this.itemsPerPage;
			return Math.ceil(l / s);
		},
		pageNumber: {
			get() {
				if (this.$route.query && this.$route.query.page) {
					return parseInt(this.$route.query.page);
				}
				return 1;
			},
			//when page number is set, update query param in route
			set(val) {
				// eslint-disable-next-line
				const { page, ...oldQuery } = this.$route.query;
				if (val === 0 || val === undefined || val === 1) {
					//remove page from query params if page number is 0 or 1
					//   this.$router.push({ query: { ...oldQuery } });
				} else {
					this.$router.push({ query: { page: val, ...oldQuery } });
				}
			}
		},
		products() {
			return this.paginated;
		},
		brands() {
			let listingArray = Object.values(this.listingData);
			return listingArray.filter(listing => {
				return parseFloat(listing.retail_price) == 0;
			});
		},
		listingName() {
			return "Specials"
		},
		showOptions() {
			let options = [12, 24, 48, 100, 1000];
			return options;
		},
	}
};
</script>

<style lang="scss" scoped>
.fade-leave-active {
	transition: all 0.3s ease;
}

.fade-enter-active {
	transition: all 0.5s ease;
	transition-delay: 0.3s;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}

// .fade-move{
//   background:red;
// }

.listingTitle{
	text-align: center;
	margin-bottom: 20px;
}

.itemContainer {
	overflow: hidden;
}

.productListingOptions{
	padding-top:10px;
	padding-bottom:10px;
	font-size:0.8em;
}

.showCount {
	//add dashes between sort options
	.displayOption {
		&:not(:last-of-type)::after {
			content: " - ";
		}

		&.current .displayOptionText {
			font-weight: bold;
		}
	}

	.displayOptionText{
		cursor:pointer;
		&:hover {
			text-decoration: underline;
		}
	}
}
</style>
